<template>
  <section class="overlay-invite">
    <div class="grid-container">
      <div class="col-6">
        <div class="list-side">
          <h4>Invite Matches To Conversation</h4>
          <input class="search" placeholder="Search Matches..." v-model="keywords" type="text">
          <div class="list-holder">
            <div :class="{ 'list-item': true, 'active': invitationList.indexOf(user['.key']) !== -1 }" v-for="user in results" v-on:click="addToList(user['.key'])" v-if="members[user['.key']] == undefined">
              <div class="image-circle">
                <img v-if="user.profileimg === 'default'" src="https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f" class="image-circle">
                <img v-else :src="user.profileimg" class="image-circle">
              </div>
              <p>{{ user.firstname + ' ' + user.surname }}</p>
            </div>
          </div>
        </div>
        <div class="list-side">
          <h4>Invite someone else:</h4>
          <div class="form-holder">
            <label>Email:</label>
            <input class="modal" type="email" v-model="email">
<!--             <label>Email:</label>
            <input class="modal success" type="email" value="email@address.com"> -->
          </div>
        </div>
        <div class="invite-bottom">
          <a href="#" class="link-simple" v-on:click.prevent="$parent.invite = false">Cancel</a>
          <a href="#" class="btn bg-three active" v-on:click.prevent="invite">Invite</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { db } from '@/firebase'

export default {
  name: 'Invite',
  props: ['chatID'],
  data () {
    return {
      keywords: '',
      email: 'email@address.com',
      invitationList: []
    }
  },
  firebase () {
    return {
      results: db.ref('users'),
      members: {
        source: db.ref('chats-members/' + this.chatID),
        asObject: true
      }
    }
  },
  methods: {
    addToList (uid) {
      if (this.invitationList.indexOf(uid) !== -1) {
        this.invitationList.splice(this.invitationList.indexOf(uid), 1)
      } else {
        this.invitationList.push(uid)
      }
    },
    invite () {
      if (this.invitationList.length < 1) {
        alert('Please select people to invite.')
      } else {
        var updates = {}
        var timestamp = Date.now()
        for (var index in this.invitationList) {
          updates['chats/' + this.chatID + '/unreads/' + this.invitationList[index]] = 0
          updates['chats-members/' + this.chatID + '/' + this.invitationList[index]] = true
          updates['users-chats/' + this.invitationList[index] + '/' + this.chatID] = {
            createdAt: 0 - timestamp,
            showAfter: 0 - timestamp
          }
        }
        db.ref().update(updates)
        this.$parent.invite = false
      }
    }
  },
  watch: {
    'keywords': function (current, previous) {
      if (current.length > 0) {
        this.$bindAsArray('results', db.ref('users').orderByChild('firstname').startAt(current).endAt(current + '\uf8ff'))
      } else {
        this.$bindAsArray('results', db.ref('users'))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Invite.vue?3ef7e8b8